import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as TriggerTimelineActions from 'Store/actions/triggerTimeline'
import KitStartTtl from './KitStartTtl'
import { nullSafe } from 'Utility/globalMethods'

const mapDispatchToProps = dispatch => ({
  ...bindActionCreators(TriggerTimelineActions, dispatch)
})

const mapStateToProps = (state) => ({
  kitStartData: nullSafe(() => state.triggerTimeline.kitStartData, {}),
  kitStartLoading: nullSafe(() => state.triggerTimeline.kitStartDataLoading, false)
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(KitStartTtl)
